// AdminStubs.jsx — Messages, Notifications, Settings, Logs
import React from "react";
import { MessageSquare, Bell, Settings, ScrollText, Construction } from "lucide-react";

function StubPage({ icon: Icon, title, description, color, bg }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: 400, textAlign: "center" }}>
      <div style={{ width: 80, height: 80, borderRadius: 20, background: bg, display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 20 }}>
        <Icon size={36} color={color} />
      </div>
      <h2 style={{ margin: "0 0 10px", fontSize: 22, fontWeight: 800, color: "#0F172A", letterSpacing: "-0.4px" }}>{title}</h2>
      <p style={{ color: "#94A3B8", fontSize: 14, margin: "0 0 24px", maxWidth: 320 }}>{description}</p>
      <div style={{ display: "flex", alignItems: "center", gap: 8, background: "#FEF9C3", border: "1px solid #FDE68A", borderRadius: 10, padding: "10px 16px", color: "#92400E", fontSize: 13, fontWeight: 500 }}>
        <Construction size={15} /> Under development — coming soon
      </div>
    </div>
  );
}

export function AdminMessages() {
  return <StubPage icon={MessageSquare} title="Messages" description="Manage all platform conversations between customers and pros." color="#6366F1" bg="#EEF2FF" />;
}

export function AdminNotifications() {
  return <StubPage icon={Bell} title="Notifications" description="Send push notifications, emails, and SMS to users." color="#F59E0B" bg="#FFFBEB" />;
}

export function AdminSettings() {
  return (
    <div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14 }}>
        {[
          { label: "Platform Name", value: "Jirani", type: "text" },
          { label: "Support Email", value: "support@jirani.ke", type: "email" },
          { label: "Commission Rate (%)", value: "15", type: "number" },
          { label: "Min Job Price (KES)", value: "500", type: "number" },
        ].map(s => (
          <div key={s.label} style={{ background: "#fff", borderRadius: 12, padding: "18px 20px", border: "1px solid #F1F5F9" }}>
            <label style={{ fontSize: 12, fontWeight: 600, color: "#94A3B8", display: "block", marginBottom: 6, textTransform: "uppercase", letterSpacing: "0.05em" }}>{s.label}</label>
            <input type={s.type} defaultValue={s.value} style={{ width: "100%", padding: "9px 12px", borderRadius: 8, border: "1px solid #E2E8F0", fontSize: 14, color: "#334155", outline: "none", boxSizing: "border-box" }} />
          </div>
        ))}
      </div>
      <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
        <button style={{ padding: "10px 24px", borderRadius: 10, border: "none", background: "#6366F1", color: "#fff", fontWeight: 600, fontSize: 13.5, cursor: "pointer" }}>Save Settings</button>
        <button style={{ padding: "10px 24px", borderRadius: 10, border: "1px solid #E2E8F0", background: "#fff", color: "#64748B", fontWeight: 600, fontSize: 13.5, cursor: "pointer" }}>Reset</button>
      </div>
    </div>
  );
}

const MOCK_LOGS = [
  { id: 1, level: "info",    message: "Admin login: super@jirani.ke",             time: "2024-07-28 09:14:02" },
  { id: 2, level: "info",    message: "Pro verified: Grace Wanjiku (ID: 1)",       time: "2024-07-28 09:20:11" },
  { id: 3, level: "warning", message: "Failed payment attempt for PAY-005",       time: "2024-07-28 10:05:44" },
  { id: 4, level: "info",    message: "Job JOB-006 marked completed",              time: "2024-07-28 10:31:22" },
  { id: 5, level: "error",   message: "Webhook delivery failed: stripe endpoint", time: "2024-07-28 11:00:00" },
  { id: 6, level: "info",    message: "New customer registered: Susan Muthoni",   time: "2024-07-28 11:18:35" },
  { id: 7, level: "info",    message: "Category 'Painting' made visible",         time: "2024-07-28 12:00:00" },
  { id: 8, level: "warning", message: "Suspicious login attempt: alice@gmail.com",time: "2024-07-28 12:44:10" },
];

const LEVEL_CONFIG = {
  info:    { color: "#0EA5E9", bg: "#E0F2FE", dot: "#0EA5E9" },
  warning: { color: "#D97706", bg: "#FEF3C7", dot: "#F59E0B" },
  error:   { color: "#DC2626", bg: "#FEE2E2", dot: "#EF4444" },
};

export function AdminLogs() {
  return (
    <div style={{ background: "#0F172A", borderRadius: 14, padding: "20px 24px", fontFamily: "monospace", border: "1px solid #1E293B" }}>
      <div style={{ fontSize: 12, color: "#475569", marginBottom: 16, fontFamily: "'DM Sans', sans-serif", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.06em" }}>System Logs — {MOCK_LOGS.length} entries</div>
      {MOCK_LOGS.map(log => {
        const cfg = LEVEL_CONFIG[log.level];
        return (
          <div key={log.id} style={{ display: "flex", gap: 14, alignItems: "flex-start", padding: "10px 0", borderBottom: "1px solid #1E293B" }}>
            <span style={{ fontSize: 11, color: "#475569", whiteSpace: "nowrap", marginTop: 1 }}>{log.time}</span>
            <span style={{ background: cfg.bg, color: cfg.color, fontSize: 10.5, fontWeight: 700, padding: "2px 7px", borderRadius: 5, textTransform: "uppercase", flexShrink: 0, fontFamily: "'DM Sans', sans-serif", letterSpacing: "0.05em" }}>{log.level}</span>
            <span style={{ fontSize: 13, color: "#CBD5E1" }}>{log.message}</span>
          </div>
        );
      })}
    </div>
  );
}